import MaritalStatus from './maritalStatus';
export default MaritalStatus;